import { render, staticRenderFns } from "./createFranchiseClinic.vue?vue&type=template&id=e26c8d9c&"
import script from "./createFranchiseClinic.vue?vue&type=script&lang=js&"
export * from "./createFranchiseClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports